import { render } from "./DetailsEstate.vue?vue&type=template&id=40eaf079&scoped=true"
import script from "./DetailsEstate.vue?vue&type=script&lang=js"
export * from "./DetailsEstate.vue?vue&type=script&lang=js"

import "./DetailsEstate.vue?vue&type=style&index=0&id=40eaf079&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\amlakplus-online\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40eaf079"]])

export default __exports__